<script setup>
import { onBeforeUnmount, ref, watch } from 'vue';
import { t } from '../i18n';

const props = defineProps({
	modelValue: { type: String, default: '' },
	mapsReady: { type: Boolean, default: false },
	attachAutocomplete: { type: Function, default: null },
});

const emit = defineEmits(['update:modelValue', 'search', 'place-selected', 'locate-me', 'open-filters']);

const inputEl = ref(null);
let detachAutocomplete = null;

function setupAutocomplete() {
	if (!props.mapsReady || !props.attachAutocomplete || !inputEl.value) return;

	detachAutocomplete = props.attachAutocomplete(inputEl.value, (place) => {
		if (place) emit('place-selected', place);
	});
}

watch(
	() => props.mapsReady,
	(ready) => {
		if (ready) setupAutocomplete();
	},
	{ immediate: true }
);

onBeforeUnmount(() => detachAutocomplete?.());

function onSubmit() {
	emit('search', props.modelValue.trim());
}

function onClear() {
	emit('update:modelValue', '');
	emit('search', '');
	inputEl.value?.focus();
}
</script>

<template>
	<form class="dealer-locator__search search-locator" role="search" @submit.prevent="onSubmit">

		<div class="search-locator__wrap">
			<button type="button" class="search-locator__search" :title="t.search" :aria-label="t.search" @click="onSubmit">
				<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
					<path fill="#fff"
						d="m18 16.6 4.3 4.3-1.4 1.4-4.3-4.3a9 9 0 1 1 1.4-1.4m-2-.7A7 7 0 0 0 11 4a7 7 0 1 0 4.9 12z" />
				</svg>
			</button>

			<input ref="inputEl" class="search-locator__input" type="search" name="dealer-search"
				:placeholder="t.searchPlaceholder" autocomplete="off" :value="modelValue"
				@input="emit('update:modelValue', $event.target.value)" />

			<button v-if="modelValue" type="button" class="search-locator__clear" :title="t.clearSearch"
				:aria-label="t.clearSearch" @click="onClear">
				<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
					<path stroke="#fff" stroke-width="2" stroke-linecap="round" d="m6 6 12 12M18 6 6 18" />
				</svg>
			</button>

			<button type="button" class="search-locator__filter" :title="t.openFilters" :aria-label="t.openFilters"
				@click="emit('open-filters')">
				<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
					<path fill="#fff" d="M7 3v3H3v2h4v3h2V3zm4 5h10V6H11zm6 5v3h4v2h-4v3h-2v-8zm-4 5H3v-2h10z" />
				</svg>
			</button>
		</div>

	</form>
</template>
